class FormConfigError extends Error {}

export default FormConfigError;
